import type { PostHog } from "posthog-js";
import { redactBearerCredentials } from "@shared/analytics/redact-bearer-credentials";

type Persistence = NonNullable<PostHog["persistence"]>;

const PERSISTED_URL_KEYS = ["$initial_person_info", "$client_session_props"] as const;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function redactPersistedUrls(persistence: Persistence): void {
  const redacted: Record<string, unknown> = {};
  for (const key of PERSISTED_URL_KEYS) {
    const stored: unknown = persistence.props[key];
    if (!isRecord(stored)) continue;
    const next = redactBearerCredentials(stored);
    if (next !== stored) redacted[key] = next;
  }
  if (Object.keys(redacted).length > 0) persistence.register(redacted);
}

export function redactPersistedLandingUrls(instance: PostHog): void {
  const persistence = instance.persistence;
  if (!persistence) return;
  persistence.set_initial_person_info();
  redactPersistedUrls(persistence);
  instance.onSessionId(() => redactPersistedUrls(persistence));
}
